import { render, staticRenderFns } from "./ListContent.vue?vue&type=template&id=2c1cdd11"
import script from "./ListContent.vue?vue&type=script&lang=js"
export * from "./ListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports